<template>
  <div class="wrapper">
    <div class="cart-t" v-if="cartAreaList.length>0&&isLogin==1">
      <div class="top">
        <span class="left">共{{cartLength}}件商品</span>
        <span class="right" @click="editType=1" v-if="editType==0">编辑</span>
        <span class="right" @click="deleteOk" style="color:#E52B25" v-else>完成</span>
      </div>
      <div class="notice" >
       <span>提示：向左滑动即可单独删除商品哦~</span>
      </div>
    </div>
    
    <div class="cart-c" id="scroll">
      <div class="cart-ctop" v-if="cartAreaList.length>0&&isLogin==1"></div>
      <div class="cartBox"  v-for="(area,areaIndex) in cartAreaList" :key="area.nbr" v-show="cartAreaList.length!=0&&isLogin==1">
        <div class="cartTitle" @click="selectall(areaIndex)">
          <img src="../../assets/images/icon_xuanzhong.png"alt v-if="area.checkState"/>
          <div :class="area.disableState? 'choice-no':'choice'" v-if="area.disableState||!area.checkState"></div>
          <span>{{area.parent_title?area.parent_title+'-':''}}{{area.title}}</span>
        </div>
        <!-- 正常商品 -->
      <van-swipe-cell
          :right-width="70"
          class="cart-cm"
          v-for="(item,index) in area.cartList"
          :key="item.nbr"
          v-show="area.cartList.length!=0&&isLogin==1"
        >
          <van-cell-group class="cart-container">
              <div class="cart-cml" @click="selected(item,area)">
              <img
                src="../../assets/images/icon_xuanzhong.png"
                alt
                v-if="item.checkState&&parseFloat(item.sum_quantity)>0&&item.inventory_state=='0'"
              />
              <div :class="(item.disableState||parseFloat(item.sum_quantity)<=0||item.inventory_state=='1')? 'choice-no':'choice'" v-if="item.disableState||parseFloat(item.sum_quantity)<=0||item.inventory_state=='1'||!item.checkState"></div>
            </div>
            <div class="cart-cmm" @click="golistdetail(item.commodity_nbr,item.rule_type)" >
              <img :src="item.commodity_first_pic + `${imgCrop}resize,w_500`" alt />
            </div>
            <div class="cart-cmr">
              <div class="cart-cmrt">
                <div
                  class="cart-cmrtl more-h"
                  style=" -webkit-box-orient: vertical;"
                  @click="golistdetail(item.commodity_nbr,item.rule_type)"
                >{{item.commodity_name}}</div>
                <div class="cart-cmrm">
                <div class="cart-div" v-if="item.inventory_state != 1"  @click="changguige(item.commodity_nbr,item.nbr, areaIndex, index,item.quantity)">
                  <div class="flex">
                    <span class="sigle-h">{{item.property}}</span>
                    <span class="img">
                      <div><img src="../../assets/images/cart/back.svg" alt /></div>
                    </span>
                  </div>
                </div>
              </div>
              </div>
              <div class="cart-cmrb" v-if="item.inventory_state == 0 && item.sum_quantity > 0">
                <div class="cart-cmrbl">¥<span>{{item.sell_price}}</span></div>
                <div class="cart-cmrbr">
                  <span class="span" @click="inputchange(index, item, parseInt(item.quantity)-parseInt(item.add_step))"><span>-</span></span>
                  <input
                    type="number"
                    v-model.number="item.quantity"
                    @change="inputchange(index, item, parseInt(item.quantity))"
                  />
                  <span class="span" @click="inputchange(index, item, parseInt(item.quantity)+parseInt(item.add_step))"><span>+</span></span>
                </div>
              </div>
              <div class="cart-cmrb"  v-if="item.inventory_state == 1 || item.sum_quantity == 0">
                <div class="cart-cmrbl">请重新选择商品规格！</div>
                <div class="spaninvalid" @click="changguige(item.commodity_nbr,item.nbr, areaIndex, index,item.quantity)">
                  <span>重选</span>
                </div>
              </div>
            </div>
          </van-cell-group>
          <div slot="right" class="deleteBtn" @click="showDeleteModal(item.nbr,area.cartList,index)">
            <img src="../../assets/images/cart/delete.svg" alt />
          </div>
        </van-swipe-cell>
      </div>
      
      <!-- 失效商品 -->
      <!-- <div class="invalidTitle" v-if="invalid.length != 0&&isLogin==1">
        <span class="left">已失效商品({{invalid.length}})</span>
        <span class="right" @click="invalidShow = true">清空失效宝贝</span>
      </div>
      <van-swipe-cell
        :right-width="70"
        class="cart-cm"
        v-for="(item,index) in invalid"
        :key="index"
        v-show="invalid.length!=0&&isLogin==1"
      >
        <van-cell-group class="cart-container">
            <div class="cart-cml" style="width:.51rem; paddingLeft:.13rem">
              <span class="tag">失效</span>
            </div>
          <div class="cart-cmm" @click="golistdetail(item.commodity_nbr)" >
            <img :src="item.commodity_first_pic + `${imgCrop}resize,w_500`" alt />
          </div>
          <div class="cart-cmr">
            <div class="cart-cmrt">
              <div
                class="cart-cmrtl more-h"
                style=" -webkit-box-orient: vertical;color:#999"
                @click="golistdetail(item.commodity_nbr)"
              >{{item.commodity_name}}</div>
            </div>
            
            <div class="cart-cmrb">
              <div class="cart-cmrbl" style="fontWeight:normal">宝贝已不能购买，下次不要错过了哦！</div>
            </div>
          </div>
        </van-cell-group>
        <div slot="right" class="deleteBtn" @click="showDeleteModal(item.nbr,'invalid',index)">
          <img src="../../assets/images/cart/delete.svg" alt />
        </div>
      </van-swipe-cell> -->
      <!-- 空 -->
      <div class="cartcm" v-show="cartAreaList.length==0&&cartLoading&&isLogin==1">
        <img src="../../assets/images/cart/noData.png" alt />
        <p>购物车空空如也</p>
        <p>快来挑好货，再忙也要享受生活</p>
      </div>
      <!-- 未登录 -->
      <div class="cartcm" v-show="isLogin==0">
        <img src="../../assets/images/cart/noData.png" alt />
        <p>您还未登录</p>
        <div class="loginBtn" @click="toLogin"><span>立即登录</span></div>
      </div>
      
      <!-- 猜你喜欢 -->
      <div class="home-content-tab">
         <div class="home-content-t-x" v-if="goods_classify.length != 0">
           <div class="home-content-tl-x">
            <div class="home-content-tlr1">
              <span>猜你喜欢</span>
            </div>
          </div>
         </div>
          <van-list v-model="loading" :finished="finished" @load="getSecondArea" :offset="20">
           <div class="tabbox">
            <div class="tabboxm" v-for="(item,index) in goods_classify" :key="index" @click="golistdetail(item.nbr,item.rule_type)">
              <div class="tabboxmt">
                <img class="img" v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt="">
                <div :class="item.quantity==='0'?'noNum':'noNum hide'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt="">
                </div>
                <img class="sales" v-if="item.start_state==0" src="../../assets/images/beSale.png" alt="">
              </div>
              <div class="border"></div>
              <div class="tanboxmm1 sigle-twoh">
                {{item.commodity_name}}
              </div>
              <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:null">{{item.commodity_summary}}</div>
              <div class="tanboxmb">
                <span class="bold"><i>￥</i>{{item[`${roleText}_price`]}}<span v-if="Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`])*100)/100}}--></span>
                </span>
              </div>
              
              <div class="couponbox">
                <span class="tanboxmbspan">￥{{item.old_price}}</span>
                <div :class="item.is_use_coupon=='0'?'coupon1 hide':'coupon1'">可用券</div>
              </div>
            </div>
          </div>
          <div class="nomore" v-show="finished==true && goods_classify.length != 0">没有更多了^v^</div>
          </van-list>
    </div>
    </div>
    <div class="dibu" v-if="cartAreaList.length!=0&&cartLoading&&isLogin==1">
      <div class="dibu-l">
        <!-- @click="selectall" -->
        <!-- <img src="../../assets/images/icon_xuanzhong.png" alt v-if="(!alselect&&editType == 0)||(!alDelSelect&&editType == 1)" />
        <img src="../../assets/images/icon_weixuan.svg" alt v-else />
        <span>全选</span> -->
      </div>
      <div style="display:flex;flex-direction:row">
       <div class="dibu-m" v-if="editType==0">
        <span>合计：</span>
        <span>¥{{totalprice}}</span>
       </div>
       <div :class="goods_num==0?'dibu-r grey':'dibu-r'" @click="gopayorder" v-if="editType==0">结算({{goods_num}})</div>
       <div :class="goods_num==0?'dibu-r grey':'dibu-r'" @click="deleteorder" v-else>删除({{goods_num}})</div>
      </div>
    </div>
    <div class="guige-popup">
      <van-popup v-model="show" position="bottom" :overlay="true">
        <div class="guige-popupt">
          <div class="guige-popuptl">
            <div class="guige-popuptll">
              <img
              @click="showImage(assessment_detail0.inventoryLogo)"
              :src="assessment_detail0.inventoryLogo" alt />
            </div>
            <div class="guige-popuptlr">
              <p>￥{{assessment_detail0[`${goods_detail.ruleType=='1'?roleText:newRoleText}Price`]}}</p>
              <p v-if="goods_detail.isQuantityShow==1">库存：{{assessment_detail0.quantity}}</p>
              <p v-else> </p>
              <p v-if="guigeCount==selectPro.length"><span>请选择</span></p>
              <p v-if="guigeCount!=selectPro.length"
              ><span>已选：</span><span class="grey" style="max-width: 4rem;">{{guige}}</span></p>
              <!-- <span>&nbsp;&nbsp;x{{cartList.length>0?cartList[guigeindex].quantity:''}}</span> -->
            </div>
          </div>
          <div class="guige-popuptr" @click="closeshowup">
            <img src="../../assets/images/icon_close.svg" alt />
          </div>
        </div>
        <div class="guige-popupc-wrap">
          <div class="guige-popupc" v-for="(item,n) in assessment" :key="n">
            <div class="guige-popupct">{{item.name}}</div>
            <div class="guige-popupcc">
              <div
                class="guige-popupccm"
                v-for="(items,index) in item.children"
                :key="index"
                v-on:click="specificationBtn(item.name,items.name,items.quantity)"
                v-bind:class="items.quantity == 0?'nostock':
                [JSON.stringify(selectPro).indexOf(JSON.stringify({key:item.name,value:items.name}))!=-1?'productActive':'']"
              >{{items.name}}</div>
            </div>
          </div>
        </div>
        <div class="guige-popupn">
          <div class="guige-popupnl">
            数量
            <span v-if="goods_detail.limitQuantity>0">(每个ID限购{{goods_detail.limitQuantity}}件)</span>
          </div>
          <div class="guige-popupnr">
            <span :style="{'color':'#999'}" v-if="quantity==0">-</span>
            <span @click="changeNum(-assessment_detail0.addStep)" :style="{'color':(lowPriceStyle?'#999':'')}" v-else>-</span>
            <input :style="{'background':'#fff'}" type="number" v-model="num" @blur="blurChange" v-if="quantity==0" disabled/>
            <input type="number" v-model="num" @blur="blurChange" v-else />
            <span  :style="{'color':'#999'}" v-if="quantity==0">+</span>
            <span @click="changeNum(assessment_detail0.addStep)" :style="{'color':(highPriceStyle?'#999':'')}" v-else>+</span>
          </div>
        </div>
        <div class="guige-popupnb">
          <div class="guige-popupnbr" @click="surechange">确定</div>
        </div>
      </van-popup>
    </div>
    <!-- 规格弹窗 -->
    <!--删除弹窗-->
    <van-popup class="closepopup" v-model="showDeleteAll" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">
          <span>温馨提示</span>
          <span>确定删除所选宝贝吗？</span>
          </van-row>
        <van-row>
          <van-col class="cancel" @click.native="showDeleteAll=false">取消</van-col>
          <van-col class="confirm" @click.native="deleteAll">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--删除弹窗-->
    <van-popup class="closepopup" v-model="showThisDelete" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">
          <span>温馨提示</span>
          <span>确定要删除当前商品吗？</span>
          </van-row>
        <van-row>
          <van-col class="cancel" @click.native="showThisDelete=false">取消</van-col>
          <van-col class="confirm" @click.native="thisDeleteOk">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
     <!--删除弹窗-->
    <van-popup class="closepopup" v-model="invalidShow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">
          <span>温馨提示</span>
          <span>确认清空失效宝贝吗？</span>
        </van-row>
        <van-row>
          <van-col class="cancel" @click.native="invalidShow=false">我再想想</van-col>
          <van-col class="confirm" @click.native="deleteAllInvalid">清空</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!-- 弹出提示地址 -->
    <!--回到顶部-->
    <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
      <img src="../../assets/images/index/top.svg" />
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      cartLength:0,
      cartAreaList:[],
      alDelSelect: true, // 删除全选状态
      showDeleteAll: false, // 删除全部显示
      showThisDelete:false, //删除单个
      editType:0, // 编辑类型
      count: "", //购物车商品数量
      invalidcount: "", //购物车失效商品数量
      show: false, //规格弹窗
      alselect: true, //全选
      cartList: [], //购物车列表
      invalid: [], //失效商品列表
      goods_id: "", //商品id
      goods_attribute: "请选择", //请选择规格
      assessment: [], //规格属性
      assessment_detail: [], //规格匹配所有属性组合
      guige: "", //已选规格
      assessment_detail0: {}, //选定规格
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      subIndex: [], //是否选中 因为不确定是多规格还是但规格，所以这里定义数组来判断
      areaIndex:0,
      guigeindex: 0, //点击的第几个商品的下标改变规格
      guigeobj: "", //改变规格对象
      attr_id: "", //商品的各种规格
      goods_price: "", //商品的各种价格
      totalprice: 0, //总价（不包括优惠券）
      goods_num: "0", //结算商品的数量
      delindex: "", //删除下标
      delectNbr: "", //删除id
      selectPro: [], //选择规格
      roleText: "sell", //用户身份文字
      newRoleText: "sell", //用户新身份文字
      selectImg: "", // 默认规格图
      mainNbr: "", //规格快照
      cartSelect: [], // 选择标记数组
      numSwitch: true, //改变数量开关
      quantity:0, // 选择商品总库存
      goods_detail:{},
      quantityArr:[], // 库存空数组
      guigeCount:0,
      keepAlive: true,
      lowPriceStyle: true, // 加减价格样式
      highPriceStyle: false,
      num:1, // 选择的商品规格数量
      startX: 0,
      endX: 0,
      loading: false, //上拉加载
      finished: false, //加载完成
      goods_classify: [], //一级分类下的商品
      pageIndex: 0,
      numPerPage: 10,
      cartLoading: false,
      invalidShow: false,
      deleteS:false,
      scroll:0,
      toTopShow:false,
      isLogin:0, //未登录

      deleteId:'',
      deleteType:'',
      deleteIndex:'',
      cartPageIndex:0,
    };
  },
  watch: {
    userInfo(){
      this.checkOption();
    },
    $route(to, from) {
      if (
        from.path == "/information" ||
        from.path == "/cart"||
        from.path == "/recommend"||
        from.path == "/index"
      ) {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  computed: {
  },
  methods: {
    toLogin(){
      this.getWeChatCode()
    },
    checkOption(){
      if(!(this.userInfo&&this.userInfo.nbr)){
        let option = {
          title: '我的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin,
          images: this.cdnImgPath + '/images/default/wx_head_default.jpg',
        }
        this.weChatShare(option);
        this.isLogin = 0;
        this.roleText = 'sell';
        this.newRoleText='sell'
        this.cartLoading = false;
      }else{
        let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
        };
        this.weChatShare(option);
        this.isLogin = 1;
        // this.getCart([]);
        this.getCartArea();
        this.getUserRole();
      }
    },
    showDeleteModal(nbr,type,index){
      this.deleteId = nbr;
      this.deleteType = type;
      this.deleteIndex = index;
      this.showThisDelete = true;
    },
    thisDeleteOk(){
      if(this.deleteS) return;
      this.deleteS = true;
      this.suredelect(this.deleteId,this.deleteType,this.deleteIndex);
    },
    deleteOk(){
      this.editType = 0;
    },
    deleteAllInvalid(){
      let deleteArr = [];
      let invalid = this.invalid;
      invalid.map((item,index)=>{
        if(item){
          deleteArr.push(item.nbr);
        }
      })
      this.$commonPost({
        jydm: "flow_30005",
        flow_30005: {
          nbr: deleteArr,
        }
      })
        .then(response => {
          this.invalidShow = false;
          this.invalid = [];
          this.$toast({
            message: response.resp_msg,
            duration: 2000
          });
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    deleteAll(){
      let that = this;
      let cartAreaList = this.cartAreaList;
      let seleteIndex, newArr = [],deleteArr = [];
      cartAreaList.forEach((el,index)=>{
        if(!el.disableState&&el.checkLength>0){
          seleteIndex = index
          el.cartList.forEach(item=>{
            if (item.checkState) {
              deleteArr.push(item.nbr);
            }else{
              newArr.push(item)
            }
          })
        }
      })
      this.$commonPost({
        jydm: "flow_30005",
        flow_30005: {
          nbr: deleteArr,
        }
      })
        .then(response => {
          this.showDeleteAll = false;
          cartAreaList[seleteIndex].cartList=newArr
          that.updateCartAreaList()
          this.editType = 0;
          this.$toast({
            message: response.resp_msg,
            duration: 2000
          });
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
     //更多推荐下商品
    getSecondArea() {
      let that = this;
       // 更多推荐
      this.$commonPost({
        jydm: "flow_70061",
        flow_70061: {
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
        }
      })
        .then(response => {
          let secondArr = [];
          if(response.commodityList){
              if (response.commodityList.commodity.length > 0) {
                secondArr = response.commodityList.commodity;
            } else {
                secondArr.push(response.commodityList.commodity);
            }
          }
          that.goods_classify = that.goods_classify.concat(secondArr);
          that.loading = false;
          if (secondArr.length < that.numPerPage) {
            that.finished = true;
          } else {
            that.pageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    changeNum(value){
      let num = this.num + value;
      if(/^\d+$/g.test(num)){
        this.num = num;
        this.checkNum();
      }
    },
    checkNum() {
      let value = this.num;
      let assessment_detail0 = this.assessment_detail0;
      let limitQuantity = this.goods_detail.limitQuantity
      this.highPriceStyle = false;
      this.lowPriceStyle = false;
      if(value <= assessment_detail0.minimumSellNum){
          value = assessment_detail0.minimumSellNum;
          this.lowPriceStyle = true;
      }
      if(limitQuantity > 0){
        if(value >= limitQuantity){
          let low = (limitQuantity - assessment_detail0.minimumSellNum) % assessment_detail0.addStep;
          value = limitQuantity - low;
          this.highPriceStyle = true;
        }else{
          value = value - (value - assessment_detail0.minimumSellNum) % assessment_detail0.addStep;
        }
      }else{
        if(value > assessment_detail0.quantity){
          let low = (assessment_detail0.quantity - assessment_detail0.minimumSellNum) % assessment_detail0.addStep;
          value = assessment_detail0.quantity - low;
          this.highPriceStyle = true;
        }else{
          value = value - (value - assessment_detail0.minimumSellNum) % assessment_detail0.addStep;
        }
      }
      this.num = parseInt(value);
    },
    showImage(img){
     wx.previewImage({
       current:img,
       urls:[img]
     })
    },
    deleteorder(){
      if(this.goods_num==0){
        return this.$toast({
            message: '请选择要删除的商品',
            duration: 2000
          });
      }
      this.showDeleteAll=true
    },
    blurChange() {
      this.checkNum()
      window.scrollTo(0, 0);
    },
    inputchange(index, item, value) {
      if (!this.numSwitch) return;
      if(!/^[1-9]\d*$/.test(value) || value <= item.minimum_sell_num){
        value = item.minimum_sell_num;
      }
      if((value - item.minimum_sell_num) % item.add_step != 0 || value > item.sum_quantity){
        let low = (item.sum_quantity - item.minimum_sell_num) % item.add_step;
        value = item.sum_quantity - low;
      }
      this.numSwitch = false;
      item.quantity = value;

      // 修改数量
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30027",
          nbr: item.nbr,
          quantity: value
        }
      })
        .then(response => {
          this.getCartArea();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      this.$forceUpdate(); //重绘
    },
    getCommodityNum(nbr){
      this.$commonPost({
      jydm: "flow_70059",
      flow_70059: {
        nbr: nbr,
        wechat_version: 1
      }
    })
      .then(response => {
        this.quantity = response.commodity.quantity;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    changguige(nbr, mainNbr,areaIndex, index, num) {
      // 商品一般信息
      // let proArr = [];
      let text = "";
      let toast = this.$toast.loading({
        mask: false,
        duration: 0
      });
      this.guigeCount = 0;
      this.num = parseInt(num);
      let thisPropertyNbr = this.cartAreaList[areaIndex].cartList[index].inventory_nbr;
      // thisProperty.split(/[,/]/).map((item, aIndex) => {
      //   if (aIndex == 0) {
      //     text = item.split(":")[1];
      //   } else {
      //     text += "," + item.split(":")[1];
      //   }
      //   let proObj = {
      //     key: item.split(":")[0],
      //     value: item.split(":")[1]
      //   };
      //   proArr.push(proObj);
      // });
      // this.selectPro = proArr;
      
      this.mainNbr = mainNbr;
      this.areaIndex = areaIndex;
      this.guigeindex = index;
      this.$post("/api/customer/queryCommodityDetail", {
          commodityNbr: nbr
        })
        .then(res => {
          let data = res.object.resp.commodity;
          if (res.code == "200") {
            let resp = res.object.resp;
            this.getCommodityNum(data.nbr)
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              let inventoryObj = data.commodityInventoryList.filter((item)=>{return item.nbr == thisPropertyNbr})[0]
              let text='', proArr = [];
              inventoryObj.propertyListJson.forEach((item,index)=>{
                if(index==0){
                  text =item.propertyValue
                }else{
                  text += "," + item.propertyValue;
                }
                let proObj = {
                  key: item.propertyName,
                  value: item.propertyValue
                };
                proArr.push(proObj);
              })
              this.selectPro=proArr
              this.guige = text;
              this.assessment = data.propertyJson;
              this.assessment_detail = data.commodityInventoryList;
              this.selectImg = data.commodityLogo;
              this.selectComodityNbr = data.nbr;
              this.goods_detail = data;
              this.checkItem(proArr);
              this.checkNoClick();
              this.thisCheckNoClick(proArr);
              toast.clear();
              this.show = true;
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            this.$toast({
              message: resp.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });

    },
    thisCheckNoClick(selectArr){
      let quantityArr = this.quantityArr;
      let propertyListJson = this.assessment;
      propertyListJson.map((json,index1)=>{
        json.children.map((child,index2)=>{
          let arr = [];
          arr.length = propertyListJson.length;
          arr[index1] = {
            propertyName:json.name,
            propertyValue:child.name,
          }
          selectArr.map((select,index3)=>{
            if(index3 != index1){
              arr[index3] = {
                propertyName:select.key,
                propertyValue:select.value,
              }
            }
          });
          if( JSON.stringify(quantityArr).indexOf(JSON.stringify(arr)) > 0 ){
            child.quantity = 0;
          }else{
            child.quantity = 1;
          }
        })
      })
      this.assessment = propertyListJson;
    },
    checkItem: function(selectPro) {
      let propertyArr = [];
      let propertyList = this.assessment_detail;
      for (let a=0; a<selectPro.length; a++) {
        let aItem = {
            propertyName: selectPro[a].key,
            propertyValue: selectPro[a].value
          };
        propertyArr.push(aItem);
      }
      let iCount = 0;
      for (let b=0; b<propertyList.length; b++) {
        let bItem = propertyList[b].propertyListJson;
        let count = 0;
        for (let c=0; c<propertyArr.length; c++) {
          if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
            ) {
              count += 1;
            }
        }
        if (count == bItem.length) {
          if(!propertyList[b].inventoryLogo){
            propertyList[b].inventoryLogo = this.selectImg;
          }
          this.assessment_detail0 = JSON.parse(JSON.stringify(propertyList[b]));
        }else{
          iCount += 1;
        }
        if(iCount == propertyList.length){
          let checkPriceChange = this.checkPriceChange;
          let assessmentDetail = this.assessment_detail0;
          let goods_detail = this.goods_detail;
          assessmentDetail.minimumSellNum = 1;
          assessmentDetail.addStep = 1;
          assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
          assessmentDetail.directorPrice = checkPriceChange(goods_detail.minDirectorPrice,goods_detail.maxDirectorPrice);
          assessmentDetail.agentPrice = checkPriceChange(goods_detail.minAgentPrice,goods_detail.maxAgentPrice);
          assessmentDetail.sellPrice = checkPriceChange(goods_detail.minSellPrice,goods_detail.maxSellPrice) ;
          assessmentDetail.quantity = this.quantity;
          this.assessment_detail0 = assessmentDetail;
        }
      }
      this.checkNum();
      this.$forceUpdate(); //重绘
    },
    getUserRole() {
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          if (response.role == 0||response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }
          if (response.new_role == 0||response.new_role == 1) {
            this.newRoleText = "sell";
          } else if (response.new_role == 2) {
            this.newRoleText = "agent";
          } else if (response.new_role == 3) {
            this.newRoleText = "director";
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    surechange() {
      if(this.guigeCount==0){
        if(!this.assessment_detail0.nbr){
          return this.$toast({
            message: '请选择规格',
            duration: 2000
          });
        }
        if(JSON.stringify(this.assessment_detail0) == '{}'){
          return this.$toast({
            message: '该商品库存为0',
            duration: 2000
          });
        }
        this.show = false;
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_30026",
            nbr: this.mainNbr,
            inventory_nbr: this.assessment_detail0.nbr,
            quantity:this.num,
          }
        })
        .then(response => {
          let cartAreaList = this.cartAreaList;
          let assessment_detail0 = this.assessment_detail0;
          let rule_type = cartAreaList[this.areaIndex].cartList[this.guigeindex].rule_type
          this.show = false;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].commodity_first_pic =
            assessment_detail0.inventoryLogo;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].minimum_sell_num =
            assessment_detail0.minimumSellNum;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].property =
            assessment_detail0.propertyComplete;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].inventory_nbr = assessment_detail0.nbr;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].add_step = assessment_detail0.addStep;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].sum_quantity = assessment_detail0.quantity;
          cartAreaList[this.areaIndex].cartList[this.guigeindex].sell_price = parseFloat(
            assessment_detail0[`${rule_type=='1'?this.roleText:this.newRoleText}Price`]
          ).toFixed(2);
          this.getCartArea();
          this.$toast({
            message: "修改成功",
            duration: 2000
          });
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      }else{
        this.$toast({
          message: '请选择规格',
          duration: 2000
        });
      }
    },
    closeshowup() {
      this.show = false;
    },
    selected(item,area) {
      if(area.disableState|| parseFloat(item.sum_quantity)<=0|| item.inventory_state=='1') return false
      item.checkState = !item.checkState
      this.updateCartAreaList()
    },
    updateCartAreaList(){
      let that = this;
      let cartAreaList = JSON.parse(JSON.stringify(that.cartAreaList));
      let allNum=0
      for(let i = cartAreaList.length-1;i>=0;i--){
        let area = cartAreaList[i]
        if(area.cartList.length==0){
          cartAreaList.splice(i, 1)
          continue
        }
        let canCheckArr = area.cartList.filter((item)=>{return parseFloat(item.sum_quantity)>0&&item.inventory_state=='0'})
			  area.canCheckLength = canCheckArr.length
        area.checkLength = canCheckArr.filter((item)=>{return item.checkState}).length
        area.disableState= area.checkLength<=0
        area.checkState= area.checkLength == area.canCheckLength
        area.cartList.forEach((item)=>{item.disableState=area.disableState})
        allNum += area.checkLength
      }
      if(allNum==0){
        cartAreaList.forEach((area)=>{
          area.disableState=false
          area.cartList.forEach((item)=>{item.disableState=area.disableState})
        })
      }
      that.cartAreaList = cartAreaList
      that.totalChecked();
      that.$forceUpdate(); //重绘
    },
    golistdetail(nbr,type) {
      this.$router.push({
        path: type=='1'?"/listdetail":"/sourceListdetail",
        query: { nbr: nbr, supNbr:this.userInfo.nbr }
      });
    },
    selectall(seletedIndex) {
      // if(area.disableState) return false
      let cartAreaList = this.cartAreaList
      let checkState = !cartAreaList[seletedIndex].checkState
      cartAreaList.forEach((area,areaIndex)=>{
        if(checkState){
          if(areaIndex==seletedIndex){
            area.disableState=false
            area.checkState = checkState
            area.cartList.forEach((item)=>item.checkState=checkState)
          }else{
            area.disableState=true
            area.cartList.forEach((item)=>{
              item.disableState = true
              item.checkState=false
            })
          }
        }else{
          area.disableState=false
          area.cartList.forEach((item)=>{
            item.disableState = false
            item.checkState=false
          })
        }
        
      })
      this.updateCartAreaList();
      this.$forceUpdate(); //重绘
    },
    suredelect(delectNbr,list,index) { //删除单个商品
      let that = this
      this.$commonPost({
        jydm: "flow_30005",
        flow_30005: {
          nbr: [delectNbr],
        }
      })
        .then(response => {
          let lists = list;
          lists.splice(index, 1);
          that.updateCartAreaList()
          this.showThisDelete = false;
          setTimeout(()=>{
            this.deleteS = false;
          },500);
          this.$toast({
            message: response.resp_msg,
            duration: 2000
          });
        })
        .catch(err => {
          this.deleteS = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    specificationBtn: function(key, value, num) {
      let text = "";
      let selectPro = this.selectPro;
      if(num == 0 ){
        return this.$toast({
            message: "该规格库存为0",
            duration: 2000
          });
      }
      selectPro.map((item, index) => {
        if (item.key == key) {
          if(item.value == value){
            selectPro[index].value = '';
          }else{
            selectPro[index].value = value;
          }
        }
      });
      let dIndex = 0;
      for (let i=0;i<selectPro.length;i++) {
        if(selectPro[i].value != ''){
          if (i == dIndex) {
            text = selectPro[i].value;
          } else {
            text += "," + selectPro[i].value;
          }
        }else{
          dIndex += 1;
        }
      }
      let assessmentDetail = this.assessment_detail0;
      let goods_detail = this.goods_detail;
      let assessment = this.assessment;
      let checkPriceChange = this.checkPriceChange;
      let count = 0;
      let inventoryList = []
      selectPro.map(item=>{
        if(item.value == ''||!item.value){
          count += 1;
        }
      })
      if( count == selectPro.length ){
        assessmentDetail.minimumSellNum = 1;
        assessmentDetail.addStep = 1;
        assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
        assessmentDetail.directorPrice = checkPriceChange(goods_detail.minDirectorPrice,goods_detail.maxDirectorPrice);
        assessmentDetail.agentPrice = checkPriceChange(goods_detail.minAgentPrice,goods_detail.maxAgentPrice);
        assessmentDetail.sellPrice = checkPriceChange(goods_detail.minSellPrice,goods_detail.maxSellPrice) ;
        assessmentDetail.quantity = this.quantity;
        this.assessment_detail0 = assessmentDetail;
        this.checkNum();
      } else if( count > 0 ){
        let propertyList = this.assessment_detail
        let propertyArr = [];
        for (let a = 0;a< selectPro.length;a++) {
          if(selectPro[a].value){
            let aItem = {
              propertyName: selectPro[a].key,
              propertyValue: selectPro[a].value
            };
            propertyArr.push(aItem);
          } 
        }
       for (let b = 0;b< propertyList.length;b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c = 0;c< propertyArr.length;c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
            ) {
              count += 1;
            }
          }
          if (count == propertyArr.length) {
            inventoryList.push(propertyList[b]);
          }
        }
        this.assessment_detail0 = JSON.parse(JSON.stringify(inventoryList[0]))
        this.checkNum();
      }else{
        this.checkItem(selectPro);
      }
      this.thisCheckNoClick(selectPro);
      this.guigeCount = count;
      this.guige = text;
      this.selectPro = selectPro;
    },
    checkPriceChange(a,b){
      if(a==b){
        return a;
      }else{
        return a + '-' + b;
      }
    },
    checkNoClick: function() {
      let propertyList = this.assessment_detail;
      let quantityArr = [];
      for(let i=0;i<propertyList.length;i++){
        if(propertyList[i].quantity == 0){
          let propertyComplete = propertyList[i].propertyListJson;
          quantityArr.push(propertyComplete);
        }
      }
      this.quantityArr = quantityArr;
    },
    isMay: function(result) {
      for (let i=0;i<result.length;i++) {
        if (result[i] == "") {
          return true; //如果数组里有为空的值，那直接返回true
        }
      }
      return this.shopItemInfo[result].num == 0 ? false : true; //匹配选中的数据的库存，若不为空返回true反之返回false
    },
    totalChecked() {
      let goods_num = 0;
      let totalprice = 0;
      let cartLength=0;
      let cartAreaList = this.cartAreaList;
      cartAreaList.forEach((el, index) => {
        if(!el.disableState&&el.checkLength>0){
          el.cartList.forEach((item)=>{
            if (item.checkState) {
              totalprice = (
                Number(totalprice) +
                Number(item.sell_price) * item.quantity
              ).toFixed(2);
              goods_num += Number(item.quantity);
            }
          })
        }
        cartLength += el.cartList.length
      });
      this.cartLength = cartLength
      this.goods_num = goods_num;
      this.totalprice = totalprice;
    },
    gopayorder() {
      var arr = [];
      let that = this;
      if (that.goods_num == 0) {
        return this.$toast({
          message: "请先选择要结算的商品",
          duration: 1000
        });
      } else {
        that.cartAreaList.forEach((el,index)=>{
          if(!el.disableState&&el.checkLength>0){
            el.cartList.forEach(item=>{
              if (item.checkState) {
                arr.push(item.nbr);
              }
            })
          }
        })
        // 库存校验
        that.$commonPost({
        jydm: "flow_30028",
        flow_30028: {
          record: {
            nbr : arr
          },
        }
      })
        .then(response => {
           that.$router.push({
            path: "/placeorder",
            query: { record: JSON.stringify({ nbr: arr }), type: 1,supNbr:this.userInfo.nbr }
          });
        })
        .catch(err => {
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
        
      }
      this.$store.commit("SENDcoupon", "");
    },
    handleScroll(){
      // 设备/屏幕高度
      let scrollTop = document.getElementById('scroll').scrollTop;
      if(scrollTop > 50){
        this.toTopShow = true;
      }else{
        this.toTopShow = false;
      }
    },
    // 回到顶部动画
    toTopAnimate(){
      document.getElementById('scroll').scrollTop = 0;
    },
    getCartArea(){
      let that = this
      this.$commonPost({
        jydm: "flow_30077",
        flow_30077: {
          user_nbr: this.userInfo.nbr,
          page_index: 0,
          num_per_page: 100,
        }
      })
        .then(response => {
          let arr = [];
          if (response.list) {
            if (response.list.length > 0) {
              arr = response.list;
            } else {
              arr.push(response.list);
            }
          }
          arr.push({
            nbr:'-1',
            parent_title:'',
            title:'溯源商品',
          },{
            nbr:'0',
            parent_title:'',
            title:'默认商品',
          })
          arr.forEach((item)=>{
            item.checkLength=0
            item.checkState=false
            item.disableState=false
            item.pageIndex=0
            item.cartList=[]
            that.getCart(item)
          })
          this.setCartAreaList(arr)
        })
        .catch(err => {
          this.cartLoading = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCart(item) {
      let that = this
      // 用户的购物列表
      // let toast = this.$toast.loading({
      //   mask: false,
      //   duration: 0
      // });
      return new Promise((resolve, reject) => {
        let params
        if(item.nbr=='0'||item.nbr=='-1'){
          params={
            jydm: "flow_30079",
            flow_30079: {
              rule_type: item.nbr=='-1'?'2':'1',
              type:'1',
              user_nbr: this.userInfo.nbr,
              page_index: item.pageIndex * 20,
              num_per_page: 20,
              version: '231'
            }
          }
        }else{
          params={
            jydm: "flow_30076",
            flow_30076: {
              type:'1',
              user_nbr: this.userInfo.nbr,
              channel_note:item.nbr,
              page_index: item.pageIndex * 20,
              num_per_page: 20,
              version: 1
            }
          }
        }
        this.$commonPost(params)
          .then(response => {
            let arr = [];
            if (response.commodity) {
              if (response.commodity.length > 0) {
                arr = response.commodity;
              } else {
                arr.push(response.commodity);
              }
            }
            item.cartList = item.cartList.concat(arr)
            if(arr.length<20){
              item.finish = true;
              resolve();
            }else{
              item.pageIndex += 1
              that.getCart(item)
            }
          })
          .catch(err => {
            reject()
            this.cartLoading = true;
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      })
    },
    setCartAreaList(arr){
      let that = this
      setTimeout(()=>{
        let length = arr.filter((item)=>{return item.finish}).length
        if(length == arr.length){
          that.cartAreaList=arr
          that.numSwitch = true;
          that.cartLoading = true;
          that.updateCartAreaList()
        }else{
          that.setCartAreaList(arr)
        }
      },500)
    }
  },
  created() {
  },
  mounted() {

  },
  activated(){
    document.title = "购物车";
    window.addEventListener('scroll', this.handleScroll, true);
    this.cartSelect = [];
    this.alselect = true;
    this.cartLength = 0;
    this.goods_num = 0;
    this.totalprice = 0;
    this.cartPageIndex = 0;
    document.getElementById('scroll').scrollTop = this.scroll;

    this.checkOption();
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementById('scroll').scrollTop;
    window.removeEventListener('scroll', this.handleScroll,true);
    next();
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.toTop{
  position: fixed;
  right: .2rem;
  z-index: 999;
  bottom: 3rem;
  width: .8rem;
  height: 0.8rem;
  background: rgba(51,51,51,0.5);
  border-radius:50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toTop img{
  width: 0.4rem;
  height: 0.4rem;
}
.home-content-tab {
  width: 100%;
  background: #f7f7f7;
  padding-bottom: 1rem;
  margin-top: .4rem;
}
.home-content-tabtop {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

.home-content-tabtop::-webkit-scrollbar {
  display: none;
}

.home-content-tabtopm {
  width: 1.08rem;
  height: 0.56rem;
  font-size: 0.28rem;
  line-height: 0.56rem;
  text-align: center;
}
.home-content-t-x {
  width: 100%;
  height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-content-tl-x {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.34rem;
  color: #333;
}
.home-content-tll {
  position: relative;
}
.home-content-tll img {
  width: 0.499rem;
  height: 0.5rem;
  margin-left: 0.3rem;
  margin-right: 0.1rem;
}
.home-content-tll span:nth-of-type(1) {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  background: #c2abfa;
  border-radius: 50%;
  position: absolute;
  top: -0.15rem;
  left: 0;
}

.home-content-tll span:nth-of-type(2) {
  display: inline-block;
  width: 0.58rem;
  height: 0.58rem;
  background: #5045d8;
  text-align: center;
  line-height: 0.58rem;
  color: #fff;
  font-size: 0.34rem;
  font-weight: bolder;
  border-radius: 50%;
  position: absolute;
  left: 0.08rem;
  top: -0.09rem;
}
.home-content-tlr1 {
  background:url(../../assets/images/cart/logo.png) no-repeat;
  background-size:100%;
  margin-left: 0.03rem;
  background-size: 2.32rem 0.38rem;
  margin-left: 0.03rem;
  width: 2.32rem;
  display: flex;
  justify-content: center;
  font-size: 0.28rem;
  color: #FE2E3F;
  height: 0.38rem;
}
.home-content-tlr1 span{
  display: flex;
  align-items: center;
}
.home-content-tr {
  margin-top: 0.32rem;
}

.home-content-tr img {
  width: 0.32rem;
  height: 0.32rem;
}
.tabbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.sigle-twoh {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.tabboxm {
  margin-top: 0.24rem;
  width: 3.42rem;
  height: 5.8rem;
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
  border: 1px solid #dddddd;
  position: relative;
}
.border {
  width: 3.26rem;
  height: 1px;
  background:#ddd;
  margin: 0 auto;
}
.tabboxm:nth-of-type(2n) {
  margin-left: 0.18rem;
}

.tabboxm:nth-of-type(2n - 1) {
  margin-left: 0.24rem;
}
.tabboxmt {
  position: relative;
}
.tabboxm .noNum {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.3);
  width: 100%;
  height: 3.43rem;
}
.tabboxm .noNum img {
  width: 3rem;
  height: 2.3rem;
}
.tabboxmt .img {
  width: 3.42rem;
  height: 3.43rem;
  object-fit: cover;
}
.tabboxmt .sales {
  width: 1.16rem;
  height: 0.3rem;
  position: absolute;
  bottom: -0.15rem;
  left: 0.1rem;
  z-index: 2;
}

.tanboxmm1 {
  width: 3.22rem;
  line-height: 0.32rem;
  height: 0.62rem;
  margin: 0 0.1rem;
  font-size: 0.24rem;
  margin-top: 0.22rem;
  color: #333333;
}

.tanboxmm2 {
  line-height: 0.32rem;
  margin: 0 0.24rem;
  margin-top: 0.15rem;
  font-size: 0.22rem;
  color: #999;
}

.tanboxmb {
  margin-top: 0.2rem;
  line-height: 0.33rem;
  overflow: hidden;
}

.tanboxmb span:nth-of-type(1) {
  color: #333;
  font-size: 0.3rem;
  margin-left: 0.08rem;
  font-weight: bold;
}
.tanboxmb span:nth-of-type(1) i:nth-of-type(1){
  font-size: 0.24rem;
  color: #333333;
}
.tanboxmb span:nth-of-type(1) span:nth-of-type(1) {
  font-size: 0.24rem;
  color: #E52B25;
  margin-left:0.04rem;
  font-weight: bold;
}
.tanboxmb span:nth-of-type(1) span:nth-of-type(1) i:nth-of-type(1){
  font-size: 0.24rem;
  color: #E52B25;
  margin-left:0.04rem;
}
.tanboxmbspan{
  font-size: 0.24rem;
  text-decoration: line-through;
  color: #666;
  margin-left: 0.08rem;
}

.tanboxmb span i {
  font-size: 0.2rem;
}
.couponbox{
  margin-top: 0.08rem;
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.couponbox span:nth-of-type(2){
  
}
.coupon1 {
  width:0.9rem;
  height:0.31rem;
  color: #f53547;
  font-size: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background:url(../../assets/images/FFF1F2.png) no-repeat;
  background-size:0.9rem 0.3rem;
  position: absolute;
  right: 0;
  bottom: 0.14rem;
}
.coupon {
  background: #fff1f2;
  color: #f53547;
  font-size: 0.18rem;
  padding: 0.02rem 0.07rem;
  border-radius: 0.04rem;
  position: relative;
  top: -0.04rem;
}
.coupon.style1 {
  border-radius: 0.04rem;
  font-size: 0.18rem;
  position: static;
  display: inline-block;
  padding: 0.06rem 0.13rem;
}
.hide {
  display: none !important;
}
.nomore {
  text-align: center;
  color: #999999;
  line-height: 30px;
  margin-top: 0.1rem;
}
.closepopup {
  border-radius: 0.18rem;
}
.popup {
  width: 6.14rem;
  height: 3.6rem;
  .content {
    height: 2.51rem;
    text-align: center;
    font-size: 0.3rem;
    color: #333333;
    flex-direction:column;
    span:first-of-type{
      font-weight:bold;
      font-size: 0.3rem;
      margin-bottom:0.3rem;
    }
  }
  .cancel {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-size: 0.3rem;
    color: #333333;
    background: #FFFFFF;
    border-right: 1px solid  #EEEEEE;
    border-top: 1px solid  #EEEEEE;
  }
  .confirm {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    background: #FFFFFF;
    font-size: 0.3rem;
    color: #E52B25;
    border-top: 1px solid  #EEEEEE;
  }
}
.nostock{
  background: #eeeeee !important;
  color: #b7b7b7 !important;
  border: 1px solid #eeeeee !important;
}
.cartcm {
  width: 100%;
  text-align: center;
  //  background: #fff;
  font-size: 0.36rem;
  margin-bottom: .4rem;
  margin-top: 1.6rem;
  position: relative;
  height:3.8rem;
}

.cartcm img {
  width: 2.3rem;
  height: 2.1rem;
  margin-bottom: 0.5rem;
}
.cartcm .loginBtn{
  width: 6.6rem;
  height: 1.52rem;
  border-radius:.76rem;
  border: 2px solid #E52B25;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top:3rem;
  transform: scale(0.5) translateX(-50%);
  transform-origin: left;
  span{
    font-size: .6rem;
    color: #E52B25;
  }
}
.cartcm p:nth-of-type(1) {
  font-size: 0.28rem;
  color: #333;
  line-height: 0.4rem;
  margin-bottom: 0.1rem;
}

.cartcm p:nth-of-type(2) {
  font-size: 0.24rem;
  color: #999;
  line-height: 0.34rem;
}

.invalidcm {
  width: 100%;
  text-align: center;
  line-height: 1rem;
  font-size: 0.36rem;
  background: #fff;
}

.wrapper {
  width: 100%;
  overflow: hidden;
  background: #f7f7f7;
  min-height: 100vh;
  // position: relative;
}

.cart-t {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index:9;
  .top{
    width: 100%;
    height: .68rem;
    background: #fff;
    position: relative;
  .left{
      color: #333;
      font-size: 0.48rem;
      position: absolute;
      left: 0.24rem;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      transform-origin: 0% 50%;
    }
    .right{
      color: #333;
      font-size: 0.48rem;
      position: absolute;
      right: 0.24rem;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      transform-origin:100% 50%;
    }
  }
  .notice{
   width: 100%;
   height: .6rem;
   position: relative;
   background: #f5f5f5;
    span{
      font-size: .4rem;
      color: #999;
      position: absolute;
      left: 0.24rem;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      transform-origin: 0;
    }
  }
}
.cart-ctop{
  height: 1.28rem;
}
.cartBox{
  margin-bottom: .2rem;
}
.cartTitle{
  width: 100%;
  height: .8rem;
  box-sizing: border-box;
  border-bottom: 1px solid #d9d9d9;
  padding-left: .24rem;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    width:0.42rem;
    height:0.42rem;
  }
  .choice{
    width:0.42rem;
    height:0.42rem;
    background: #ffffff;
    border: 1px solid #999999;
    border-radius: 50%;
    box-sizing: border-box;
  }
  .choice-no{
    width:0.42rem;
    height:0.42rem;
    background: #EEEEEE;
    border: 1px solid #999999;
    border-radius: 50%;
    box-sizing: border-box;
  }
  span{
    margin-left: .24rem;
    font-size: .26rem;
    color:#000;
  }
}
.cart-c {
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  height: 100vh;
  //margin-top: 1.28rem;
  padding-bottom: 1.5rem;
  // background: #f7f7f7;
}
.invalidTitle{
  width: 100%;
  height: .6rem;
  line-height: 0.6rem;
  box-sizing:border-box;
  margin-top: 0.3rem;
  padding-left: .24rem;
  padding-right: 0.24rem;
  font-size: .24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
.left{
    color: #333;
    font-weight: bold;
  }
  .right{
    color: #E52B25;
  }
}

.cart-cm {
  background: #fff;
  // padding-right: 0.3rem;
  margin-bottom: 0.06rem;
  &:last-child{
    margin-bottom: 0;
  }
}
.cart-cm::-webkit-scrollbar {
 display: none;
}
.cart-container{
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 2.32rem;
}
.deleteBtn{
  height: 2.32rem;
  background: #E52B25;
  display: flex;
  align-items: center;
  img{
    width: .4rem;
    height: 0.4rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
}
.cart-cml {
  padding: 0.94rem 0 0 0.22rem;
  img{
    width:0.42rem;
    height:0.42rem;
  }
  .tag{
    width: 1.24rem;
    height: 0.56rem;
    line-height: 0.56rem;
    background: #aaa;
    border-radius:.28rem;
    color: #fff;
    font-size: 0.4rem;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    transform: scale(0.5);
    transform-origin: left;
  }
  .choice{
    width:0.42rem;
    height:0.42rem;
    background: #ffffff;
    border: 1px solid #999999;
    border-radius: 50%;
    box-sizing: border-box;
  }
  .choice-no{
    width:0.42rem;
    height:0.42rem;
    background: #EEEEEE;
    border: 1px solid #999999;
    border-radius: 50%;
    box-sizing: border-box;
  }
}

.cart-cmm {
  margin: 0.24rem 0 0 0.22rem;
}

.cart-cmm img {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.2rem;
  object-fit: cover;
}

.cart-cmr {
  margin-left: 0.2rem;
  margin-top: 0.24rem;
  margin-right: .3rem;
  font-size: 0.24rem;
  height: 1.8rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cart-cmrt {
  width: 4.44rem;
}

.cart-cmrtl {
  line-height: 0.32rem;
  word-break:break-all;
}

.cart-cmrtr {
  margin-left: 0.1rem;
}

.cart-cmrtr img {
  width: 0.32rem;
  height: 0.32rem;
}

.cart-cmrm {
  margin-top: 0.11rem;
  .cart-div{
    color: #999;
    height: .34rem;
    box-sizing:border-box;
    display: inline-block;
    .flex{
      display: flex;
      padding: 0.12rem 0.16rem;
      height: .44rem;
      align-items: center;
      transform: scale(.5);
      transform-origin: 0% 0%;
      background: #f5f5f5;
    }
    .sigle-h{
      max-width: 7.8rem;
      display: inline-block;
      font-size: 0.4rem;
      position: relative;
    }
  }
}
.cart-cmrm .img{
  height: 100%;
  display: inline-block;
  position: relative;
  margin-left: 0.12rem;
  div{
    width: 0.48rem;
    img{
      width: 0.48rem;
      height: 0.48rem;
      position: absolute;
      transform-origin: center;
      transform: rotate(-90deg);
    }
  }
}

.cart-cmrb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position:relative;
}

.cart-cmrbl {
  font-size: 0.24rem;
  font-weight: bold;
  color: #333;
  span{
    font-size: 0.34rem;
    margin-left: .02rem;
  }
}

.cart-cmrbr {
   display: flex;
   align-items: center;
   justify-content: center;
   border: 1px solid #999;
   border-radius:.29rem;
}
.spaninvalid{
  width: 2.4rem;
  height: 0.92rem;
  border: 1px solid #E52B25;
  border-radius: 0.46rem;
  font-size: 0.48rem;
  color: #E52B25;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5) translateX(50%);
  position: absolute;
  right: 0;
}
.cart-cmrbr .span {
  display: inline-block;
  width: 0.46rem;
  height: 0.46rem;
  text-align: center;
  line-height: 0.46rem;
  vertical-align: middle;
  color: #333;
  font-size: 0.24rem;
  position: relative;
  span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}
.cart-cmrbr .span:first-child{
  border-top-right-radius:0;
  border-bottom-right-radius:0;
}
.cart-cmrbr .span:last-child{
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}

.cart-cmrbr input {
  width:.86rem;
  height: 0.46rem;
  text-align: center;
  border: none;
  outline: 0;
  vertical-align: middle;
  border-radius:0;
  border-left: 1px #999 solid;
  border-right:1px #999 solid;
  color: #333;
  font-size: 0.24rem;
}

.guige-popup {
  position: relative;
}

.guige-popupt {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0.24rem;
  margin-top: 0.24rem;
}

.guige-popuptl {
  display: flex;
  flex-direction: row;
}

.guige-popuptlr {
  margin-left: 0.28rem;
}

.guige-popuptlr p:nth-of-type(1) {
  color: #E52B25;
  font-size: 0.36rem;
  margin-top: 0.1rem;
}

.guige-popuptlr p:nth-of-type(2) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  line-height: 0.35rem;
  color: #999;
}
.guige-popuptlr p:nth-of-type(3) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 4.72rem;
  line-height: 0.35rem;
  display: flex;
  justify-content: flex-start;
}
.guige-popuptll img {
  width: 1.96rem;
  height: 1.96rem;
  border-radius: 0.2rem;
  object-fit:cover;
}

.guige-popupc-wrap {
  width: 100%;
  margin-top: 0.2rem;
  // height: 4.7rem;
  overflow-y: auto;
  margin-bottom: 0.2rem;
}

.guige-popupct {
  font-size: 0.24rem;
  margin-left: 0.24rem;
  margin-top: 0.4rem;
}

.guige-popupcc {
  width: calc(100% - 0.24rem);
  margin-left: 0.12rem;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
}

.guige-popupccm {
  padding: 0.05rem 0.25rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.5rem;
  margin-right: 0.12rem;
  margin-left: 0.12rem;
  margin-top: 0.24rem;
  border: 1px solid #999;
  font-size: 0.24rem;
  line-height: 0.34rem;
}

.guige-popupn {
  margin: 0 0.24rem .28rem;
  // height: 1.08rem;
  line-height: 1.08rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  position: relative;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  box-sizing:border-box;
  align-items: center;
  margin-bottom: 1.3rem;
}

.guige-popupnb {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
}

.guige-popupnbl {
  width: 3.74rem;
  text-align: center;
  line-height: 1.08rem;
  font-size: 0.32rem;
  color: #fff;
  background: #ff7a84;
}

.guige-popupnbr {
  width: 100%;
  text-align: center;
  line-height: .98rem;
  font-size: 0.3rem;
  color: #fff;
  background: #E52B25;
}

.guige-popupnl span {
  margin-left: 0.4rem;
  color: #999;
}
.guige-popupnr{
    border-radius: 0.29rem;
    border: 1px solid #999;
    height: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.2rem;
}
.guige-popupnr span {
  display: inline-block;
  width: 0.6rem;
  height: 0.58rem;
  text-align: center;
  line-height: 0.58rem;
  vertical-align: middle;
  border-right: none;
}

.commoditySummary{
  max-width: 3rem;
  line-height: 1.5;
  margin: 0 0.1rem;
  font-size: 0.2rem;
  margin-top: 0.1rem;
  color: #FF3500;
  font-weight: 500;
  padding: 0.04rem 0.1rem;
  border-radius: 0.04rem;
  display: inline-block;
  height: .26rem;
}

.guige-popupnr input {
  width: 1rem;
  line-height: 0.58rem;
  text-align: center;
  outline: 0;
  padding-top: 0.01rem;
  vertical-align: middle;
  border: none;
  border-radius: 0;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
  box-sizing: border-box;
}

.invalid {
  margin-top: 0.66rem;
}

.invalid-t {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 0.28rem;
}

.invalid-tl {
  font-size: 0.32rem;
  // margin-left: 0.28rem;
}

.invalid-tr {
  width: 2.24rem;
  height: 0.56rem;
  background: #5045d8;
  border-radius: 0.5rem;
  color: #fff;
  font-size: 0.28rem;
  line-height: 0.56rem;
  text-align: center;
}

.invalid-c {
  width: 7.01rem;
  background: #fff;
  padding: 0.24rem 0;
  margin: 0 0.24rem;
  margin-top: 0.26rem;
}

.invalid-cm {
  display: flex;
  flex-direction: row;
  margin: 0 0.24rem;
  margin-top: 0.24rem;
}

.invalid-cml {
  position: relative;
  width: 1.8rem;
  height: 1.8rem;
}

.invalid-cml img {
  width: 1.8rem;
  height: 1.8rem;
}

.invalid-cml span {
  width: 100%;
  height: 0.52rem;
  line-height: 0.52rem;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  color: #bbb;
  position: absolute;
  left: 0;
  bottom: 0;
}

.invalid-cmr {
  margin-left: 0.26rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.invalid-cmrt {
  font-size: 0.24rem;
  color: #999;
  width: 4.4rem;
  line-height: 0.36rem;
}

.invalid-cmrb {
  font-size: 0.24rem;
}

.guige-popupcc .productActive {
  background-color: #E52B25 !important;
  color: #fff !important;
  border: 1px solid #E52B25 !important;
  box-sizing: border-box;
}

.guige-popupcc .noneActive {
  background-color: #ccc !important;
  opacity: 0.4 !important;
  color: #000 !important;
  pointer-events: none !important;
}

.dibu {
  position: fixed;
  left: 0;
  bottom: .96rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 1.08rem;
  background: #fff;
  z-index:11;
}

.dibu-l {
  margin-left: 0.28rem;
  display: flex;
  align-items: center;
}

.dibu-l img {
  width: 0.4rem;
  height: 0.4rem;
}

.dibu-l span {
  font-size: 0.28rem;
  color: #333;
  margin-left: 0.2rem;
}
.dibu-m{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.24rem;
  span{
    color: #333;
    font-size: 0.28rem;
  }
}

.dibu-r {
  width: 2.1rem;
  height: .74rem;
  background: #E52B25;
  color: #fff;
  line-height: .74rem;
  text-align: center;
  font-size: 0.3rem;
  border-radius:.37rem;
  margin-right: .24rem;
}
.dibu-r.grey{
  background: #ccc;
}

。.vanbox {
  width: 5.18rem;
  height: 2.96rem;
  border-radius: 0.2rem;
  overflow: hidden;
}

.vanboxt {
  margin: 0 auto;
  width: 3.08rem;
  height: 0.8rem;
  text-align: center;
  margin-top: 0.6rem;
  font-size: 0.28rem;
  color: #999;
  line-height: 0.32rem;
}

.vanboxb {
  display: flex;
  flex-direction: row;
  margin-top: 0.6rem;
}

.vanboxbl {
  width: 2.6rem;
  height: 0.96rem;
  background: #f5f5f5;
  line-height: 0.96rem;
  text-align: center;
}

.vanboxbr {
  width: 2.6rem;
  height: 0.96rem;
  background: #f5f5f5;
  color: #E52B25;
  line-height: 0.96rem;
  text-align: center;
}

.addpopup .van-popup {
  border-radius: 0.3rem !important;
}
.guige-popuptr {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
}
.guige-popuptr img {
  width: 0.4rem;
}
</style>
<style lang="stylus" scoped>
.guige-popup >>> .van-popup {
  // height: 9.48rem;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/cart/cart.vue